import { defaultArg } from "./fable_modules/fable-library-js.4.19.0/Option.js";

function enableSprinklrChat(id, firstName, lastName, email, hash, kundennummer, sprinklrAppid) {
    configureChatWidget(id,firstName,lastName,email,hash,kundennummer,sprinklrAppid);
}

export function enableChatWidget(id, firstName, lastName, email, hash, kdnr, sprinklrAppId) {
    enableSprinklrChat(id, firstName, lastName, email, hash, defaultArg(kdnr, ""), sprinklrAppId);
}

export function disableChatWidget() {
    removeChatWidget();
}

//# sourceMappingURL=ChatWidget.fs.js.map
